import React, { useState } from 'react';
import { Menu, MenuItem, IconButton } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import SideNav from '../side-Nav/side-Nav';
import NotificationsPanel from '../notifications-panel/notifications-panel';
import hamburgerIcon from '../../assets/images/hamburger.svg';
import logoutIcon from '../../assets/images/Admin.svg';
import logoutHoverIcon from '../../assets/images/AdminAct.svg';
import notificationIcon from '../../assets/images/notifications.svg';
import notificationHoverIcon from '../../assets/images/notificationsAct.svg';
import './header.css';
import { withTheme } from '@emotion/react';

const Header = ({ children }) => {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [sideNavOpen, setSideNavOpen] = useState(true);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { instance } = useMsal();

  const toggleSidenav = () => setSideNavOpen(prev => !prev);
  const togglePanel = () => setVisible(prev => !prev);
  const closeOverlay = () => setVisible(false);
  
  const logout = () => {
    // Import the secure logout function
    import('../../services/auth').then(({ secureLogout }) => {
      secureLogout(instance);
    }).catch((error) => {
      console.error('[Header] Failed to import secure logout:', error);
      // Fallback to basic logout
      const isSupplier = sessionStorage.getItem('user_type') === 'supplier';
      if (isSupplier) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = '/login';
      } else {
        instance.logoutRedirect({
          postLogoutRedirectUri: process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URI || window.location.origin + '/'
        });
      }
    });
  };
  
  const handleRedirect = () => navigate('/create-new-8D');

  return (
    <div className="layout-container">
      {/* Header */}
      <header className="header-bar">
        <div className="header-content">
          <button className="MenuToggle" onClick={toggleSidenav}>
            <img src={hamburgerIcon} alt="Hamburger" />
          </button>
          <div className="titlebar">
            <h2>8D System</h2>
          </div>
          <div className="headerBtn">
            <IconButton
              className="logout"
              onClick={(e) => setMenuAnchor(e.currentTarget)}
            >
              <img src={logoutIcon} alt="Logout" className="default-icon" />
              <img src={logoutHoverIcon} alt="Hover Icon" className="hover-icon" />
            </IconButton>
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={() => setMenuAnchor(null)}
            >
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
            <button className="notification" onClick={togglePanel}style={{ border: '0px', background:'#fff'}}>
              <img src={notificationIcon} alt="Notifications" className="default-icon" />
              <img src={notificationHoverIcon} alt="Hover Icon" className="hover-icon" />
            </button>
          </div>
        </div>
      </header>

      {/* Body */}
      <div className={`layout-body ${sideNavOpen ? 'nav-open' : 'nav-closed'}`}>
        <SideNav
          open={sideNavOpen}
           onStateChange={setSideNavOpen}
          screenWidth={window.innerWidth}
          handleRedirect={handleRedirect}
        />
<main className="main-content">
  {children}
</main>
      </div>
      <NotificationsPanel open={visible} onClose={closeOverlay} />
      {visible && <div className="overlayNotify" onClick={closeOverlay}></div>}

    </div>
  );
};

export default Header;
